import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=246d3dba&scoped=true&"
import script from "./AdminSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=246d3dba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246d3dba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
